export default "__VITE_ASSET__CJ_tbWun__"